import { type Router } from 'vue-router'
import Auth0Plugin, { getRedirectSuffix, type Auth0PluginOptions } from '@fusion/auth-v3'
import permissionsOptions from '@/permissions/permissions'

export const getAuthOptions = (router: Router): Auth0PluginOptions => {
  const authOptions: Auth0PluginOptions = {
    onRedirectCallback: async (appState: { targetUrl?: string }) => {
      try {
        await router.isReady()
        await router.push(appState?.targetUrl ? appState.targetUrl : window.location.pathname)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Auth redirect: failed to navigate back to target route:', error)
      }
    },
    redirectSuffix: getRedirectSuffix(APP_ENV.VITE_APP_PUBLIC_PATH),
    accountsHost: APP_ENV.VITE_APP_ACCOUNTS_HOST,
    audience: APP_ENV.VITE_APP_API_AUDIENCE,
    clientID: APP_ENV.VITE_APP_API_CLIENT,
    domain: APP_ENV.VITE_APP_API_DOMAIN,
    useRefreshTokens: APP_ENV.VITE_APP_API_USE_REFRESH_TOKENS.toLowerCase() === 'true',
    permissionsOptions
  }

  // window.Cypress is racy at this boot point (see cypress/support/e2e.ts window:before:load for why)
  const isE2ETest = window.localStorage.getItem('tsi.e2eTest') === 'true'
  if (isE2ETest && APP_ENV.VITE_APP_AUTH_CACHE) {
    authOptions.cacheLocation = APP_ENV.VITE_APP_AUTH_CACHE as 'localstorage' | 'memory'
  }

  return authOptions
}

export default Auth0Plugin
